"use strict";

exports.__esModule = true;
exports.default = exports.IS_NOT_MATCHED_VALUE = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("../styles");

var _is = require("../utils/is");

var _Input = _interopRequireDefault(require("./Input"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var IS_NOT_MATCHED_VALUE = 'IS_NOT_MATCHED_VALUE';
exports.IS_NOT_MATCHED_VALUE = IS_NOT_MATCHED_VALUE;

var getResultContent = function getResultContent(data, renderResult) {
  if ((0, _is.isObject)(data) && data.IS_NOT_MATCHED_VALUE) {
    return (0, _is.isObject)(data.value) ? renderResult(data.value) : data.value;
  }

  return renderResult(data);
}; // eslint-disable-next-line


function Item(_ref) {
  var renderResult = _ref.renderResult,
      data = _ref.data,
      disabled = _ref.disabled,
      onClick = _ref.onClick;
  var value = data;
  var click = disabled || !onClick ? undefined : function () {
    return onClick(value);
  };
  var synDisabled = disabled || !click;
  return _react.default.createElement("a", {
    tabIndex: -1,
    className: (0, _styles.selectClass)('item', disabled && 'disabled'),
    onClick: click
  }, getResultContent(data, renderResult), !synDisabled && _react.default.createElement("span", {
    className: (0, _styles.selectClass)('indicator', 'close')
  }));
}

var Result =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Result, _PureComponent);

  function Result(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.handleRemove = _this.handleRemove.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Result.prototype;

  _proto.handleRemove = function handleRemove() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var onRemove = this.props.onRemove;
    setTimeout(function () {
      onRemove.apply(void 0, args);
    }, 10);
  };

  _proto.renderClear = function renderClear() {
    var _this$props = this.props,
        onClear = _this$props.onClear,
        result = _this$props.result,
        disabled = _this$props.disabled;

    if (onClear && result.length > 0 && disabled !== true) {
      /* eslint-disable */
      return _react.default.createElement("div", {
        onClick: onClear,
        className: (0, _styles.selectClass)('close-warpper')
      }, _react.default.createElement("a", {
        tabIndex: -1,
        "data-role": "close",
        className: (0, _styles.selectClass)('indicator', 'close'),
        href: "javascript:;"
      }));
      /* eslint-enable */
    }

    return null;
  };

  _proto.renderInput = function renderInput(text, key) {
    if (key === void 0) {
      key = 'input';
    }

    var _this$props2 = this.props,
        multiple = _this$props2.multiple,
        onFilter = _this$props2.onFilter,
        trim = _this$props2.trim,
        focus = _this$props2.focus,
        onInputFocus = _this$props2.onInputFocus,
        onInputBlur = _this$props2.onInputBlur,
        setInputReset = _this$props2.setInputReset;
    return _react.default.createElement(_Input.default, {
      key: key + "." + (focus ? 1 : 0),
      onInputFocus: onInputFocus,
      onInputBlur: onInputBlur,
      updatAble: !multiple,
      multiple: multiple,
      focus: focus,
      text: text,
      trim: trim,
      onFilter: onFilter,
      setInputReset: setInputReset
    });
  };

  _proto.renderPlaceholder = function renderPlaceholder() {
    var _this$props3 = this.props,
        focus = _this$props3.focus,
        onFilter = _this$props3.onFilter;

    if (focus && onFilter) {
      return this.renderInput(' ');
    }

    return _react.default.createElement("span", {
      className: (0, _classnames.default)((0, _styles.inputClass)('placeholder'), (0, _styles.selectClass)('ellipsis'))
    }, this.props.placeholder, "\xA0");
  };

  _proto.renderResult = function renderResult() {
    var _this2 = this;

    var _this$props4 = this.props,
        multiple = _this$props4.multiple,
        compressed = _this$props4.compressed,
        result = _this$props4.result,
        renderResult = _this$props4.renderResult,
        onFilter = _this$props4.onFilter,
        focus = _this$props4.focus,
        datum = _this$props4.datum,
        filterText = _this$props4.filterText;

    if (multiple) {
      var neededResult = compressed ? result.slice(0, 1) : result;
      var items = neededResult.map(function (d, i) {
        return _react.default.createElement(Item, {
          key: i,
          data: d,
          disabled: datum.disabled(d),
          onClick: compressed ? undefined : _this2.handleRemove,
          renderResult: renderResult
        });
      });

      if (compressed && result.length > 1) {
        items.push(_react.default.createElement("a", {
          tabIndex: -1,
          key: result.length,
          className: (0, _styles.selectClass)('item', 'item-compressed')
        }, _react.default.createElement("span", null, "+" + (result.length - 1))));
      }

      if (focus && onFilter) {
        items.push(this.renderInput(filterText, result.length));
      }

      return items;
    }

    if (onFilter) {
      return this.renderInput(getResultContent(result[0], renderResult));
    }

    return _react.default.createElement("span", {
      className: (0, _styles.selectClass)('ellipsis')
    }, getResultContent(result[0], renderResult));
  };

  _proto.render = function render() {
    var compressed = this.props.compressed;
    var result = this.props.result.length === 0 ? this.renderPlaceholder() : this.renderResult();
    return _react.default.createElement("div", {
      className: (0, _styles.selectClass)('result', compressed && 'compressed')
    }, result, !this.props.multiple && // eslint-disable-next-line
    _react.default.createElement("a", {
      tabIndex: -1,
      className: (0, _styles.selectClass)('indicator', 'caret'),
      href: "javascript:;"
    }), this.renderClear());
  };

  return Result;
}(_react.PureComponent);

Result.propTypes = {
  datum: _propTypes.default.object,
  disabled: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func]),
  filterText: _propTypes.default.string,
  focus: _propTypes.default.bool,
  multiple: _propTypes.default.bool.isRequired,
  onRemove: _propTypes.default.func,
  onClear: _propTypes.default.func,
  onFilter: _propTypes.default.func,
  onInputBlur: _propTypes.default.func,
  onInputFocus: _propTypes.default.func,
  result: _propTypes.default.array.isRequired,
  renderResult: _propTypes.default.func.isRequired,
  placeholder: _propTypes.default.string,
  setInputReset: _propTypes.default.func,
  compressed: _propTypes.default.bool,
  trim: _propTypes.default.bool
};
var _default = Result;
exports.default = _default;